import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { isEqual, get } from 'lodash';
import BarChart from 'components/molecules/charts/BarChart';
import RenderingTile from 'components/molecules/RenderingTile';

class SocialConversionsChart extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(
            get(nextProps, 'actions.data', null),
            get(this.props, 'actions.data', null));
    }

    render() {
        const { actions, exportNamePrefix } = this.props;
        const totalActionConversions = get(actions, 'statistics.conversions', 0);
        const hasActionsData = get(actions, 'hasData', null);
        const hasDataAndConversions = hasActionsData && !!totalActionConversions;
        const conversionActions = actions && actions.data &&
            actions.data.reduce((prev, data) => {
                const actionTypeName = actions.actionTypeMap[data.action_type].actionType;
                const statistics = actions[data.action_type];
                // In the conversions module, we only want to consider Actions with conversions
                if (statistics.conversions > 0) {
                    prev.data.push(statistics);
                    prev.categories.push(actionTypeName);
                }
                return prev;
            }, { categories: [], data: [], total: totalActionConversions });

        return (hasDataAndConversions ?
            <BarChart
                title="CONVERSIONS"
                exportName={`${exportNamePrefix}-actions-conversions`}
                data={conversionActions.data || []}
                y="conversions"
                yAxisLabel="Conversions"
                animateDuration={2000}
                categories={conversionActions.categories} />
            :
            <RenderingTile height='400px' show={hasDataAndConversions} />);
    }
}

SocialConversionsChart.propTypes = {
    actions: PropTypes.object.isRequired,
    exportNamePrefix: PropTypes.string.isRequired
};

export default withTheme(SocialConversionsChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/SocialConversionsChart.js